/* A WRITE THAT FAILS IS ALWAYS SAID OUT LOUD.

   Fifteen buttons across the console fired a write and attached no handler for the
   failure. Fixing fifteen call sites fixes fifteen call sites; the sixteenth, written
   next month, would be silent again. Every one of those helpers REJECTS its promise, so
   an unhandled rejection is exactly the set we want and there is one place to catch it.

   Deliberately not a replacement for a page's own message -- a page that already says
   something specific has handled its rejection and never reaches here. This is the floor,
   not the ceiling.

   IT ALSO OWNS THE ONE TEST FOR "DID THE SERVER ACTUALLY REFUSE?" -- see lcFailed below.
   This file was chosen because it is already in `web_include_js`, so it is present on every
   console page without adding a request, and it is already the module about surfacing
   failure. */
(function () {
  var BOX = "lc-tellme";
  function show(text) {
    var el = document.getElementById(BOX);
    if (!el) {
      el = document.createElement("div");
      el.id = BOX;
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.setAttribute("role", "alert");
    el.className = "on";
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.className = ""; }, 9000);
  }

  /* ---------------------------------------------------------------------------------
     A SERVER MESSAGE IS NOT A REFUSAL. `raise_exception` IS.

     Thirteen console pages each carried their own copy of

         function bad(r) { return !r || !!(r.exc || r.exc_type || r._server_messages); }

     and twelve of them were byte-identical. That test calls ANY message from the server a
     failure -- so a purely informational `frappe.msgprint` painted a completely successful
     action red. It bit the owner on 20 Aug 2026: an invite that created the user, set the
     department and sent the email was reported as a failure, because Frappe warns
     "Newly created user X has no roles enabled" on the way past.

     Measured, not assumed. `frappe.msgprint` produces
         {message, title}
     and `frappe.throw` produces
         {message, title, indicator: "red", raise_exception: 1, __frappe_exc_id}
     so `raise_exception` is exactly the discriminator, and `exc`/`exc_type` still catch a
     real exception independently.

     CONSERVATIVE IN THE DIRECTION THAT KEEPS YOU INFORMED: no response at all, an `exc`, or
     messages we cannot parse all count as failure. Only a cleanly-parsed set with no
     raising member is a success. Hiding a real failure is the worse error of the two. */

  function parseMessages(r) {
    var out = [];
    try {
      var raw = JSON.parse((r && r._server_messages) || "[]");
      for (var i = 0; i < raw.length; i++) {
        var o = raw[i];
        if (typeof o === "string") {
          try { o = JSON.parse(o); } catch (e) { o = { message: o }; }
        }
        if (o) out.push(o);
      }
    } catch (e) {
      return null;           /* unreadable -- the caller treats this as a failure */
    }
    return out;
  }

  function lcFailed(r) {
    if (!r) return true;
    if (r.exc || r.exc_type) return true;
    if (!r._server_messages) return false;
    var msgs = parseMessages(r);
    if (msgs === null) return true;
    for (var i = 0; i < msgs.length; i++) {
      if (msgs[i] && msgs[i].raise_exception) return true;
    }
    return false;
  }

  /* Markup stripped, because `frappe.bold()` emits <strong> and every one of these pages
     renders the text with textContent -- so the owner was shown the tags as literal text. */
  function strip(s) {
    return String(s === null || s === undefined ? "" : s).replace(/<[^>]*>/g, "").trim();
  }

  /* THE MESSAGE THAT EXPLAINS THE REFUSAL, not merely the first one in the queue. Sixteen
     pages took `m[0]`, so an incidental notice queued ahead of a real error hid it. */
  function lcMessage(r) {
    var msgs = parseMessages(r) || [];
    for (var i = 0; i < msgs.length; i++) {
      if (msgs[i] && msgs[i].raise_exception) return strip(msgs[i].message);
    }
    if (msgs.length) return strip(msgs[0].message);
    return strip((r && r.exc_type) || "");
  }

  window.lcFailed = lcFailed;
  window.lcMessage = lcMessage;

  /* SOMEBODY ELSE'S BUG IS NOT OUR ALARM.

     A browser extension that patches XMLHttpRequest throws inside its OWN bundle while
     inspecting our responses. The rejection is unhandled, so it arrived here and the owner
     was shown "Cannot read properties of undefined (reading 'M_ID')" on a page that had in
     fact rendered perfectly -- an Edge extension, 19 Aug 2026. A reporter that blames us
     for a third party's fault is worse than no reporter, because it teaches the owner to
     ignore the red box.

     Suppressed ONLY when we are certain: the stack names an extension AND carries no
     http(s) frame, i.e. not one line of it is code we served. No stack at all -> still
     shown, because a silent failure is the worse error of the two.

     THE SAME RULE, WORD FOR WORD, IS IN guards/jserrors.py -- which LABELS these rather
     than dropping them, so they stay diagnosable in Error Log. Keep the two in step: if
     you change the test here, change it there. */
  function notOurs(r) {
    var s = String((r && r.stack) || "");
    if (s.indexOf("-extension://") === -1) return false;
    return s.indexOf("http://") === -1 && s.indexOf("https://") === -1;
  }

  window.addEventListener("unhandledrejection", function (e) {
    var r = e && e.reason;
    if (!r) return;
    if (notOurs(r)) return;
    var m = (typeof r === "string") ? r : (r.message || r.exc_type || "");
    if (!m || typeof m !== "string") return;
    // Frappe's own dialogs already tell people about these.
    if (/csrf|not permitted to view/i.test(m)) return;
    show(m.replace(/<[^>]*>/g, "").slice(0, 220));
  });
})();
